import DelayedAction from '../../utils/DelayedAction';

const DELAY = 400;
const DELAY_CSS_TRANSITION = 50;

const Key = {
  Escape: 27,
};

class Tooltip {
  $container: HTMLElement;

  $button: HTMLButtonElement;

  $tooltip: HTMLElement;

  isKeydownHandlerAttached: boolean;

  showDelay: DelayedAction;

  isVisible: boolean;

  constructor($container: HTMLElement, buttonSelector = 'button', tooltipSelector = '.tn-tooltip') {
    const $button = $container.querySelector<HTMLButtonElement>(buttonSelector);
    const $tooltip = $container.querySelector<HTMLElement>(tooltipSelector);

    if (!$button || !$tooltip) {
      throw new Error();
    }

    const tooltipId = $tooltip.getAttribute('id');

    if (!tooltipId) {
      throw new Error();
    }

    this.$container = $container;
    this.$button = $button;
    this.$tooltip = $tooltip;

    this.$button.setAttribute('aria-labelledby', tooltipId);

    this.$tooltip.setAttribute('aria-hidden', 'true');
    this.$tooltip.style.display = 'none';

    this.showDelay = new DelayedAction(DELAY - DELAY_CSS_TRANSITION, {
      onTime: this.showTooltip,
    });

    this.isKeydownHandlerAttached = false;
    this.isVisible = false;

    this.$container.addEventListener('mouseenter', this.showDelay.reset);
    this.$button.addEventListener('focus', this.showDelay.reset);

    this.$container.addEventListener('mouseleave', this.hideTooltip);
    this.$button.addEventListener('blur', this.hideTooltip);
  }

  attachKeydownHandler() {
    if (this.isKeydownHandlerAttached) {
      return;
    }

    document.addEventListener('keydown', this.onKeyDown);

    this.isKeydownHandlerAttached = true;
  }

  removeGlobalListener() {
    document.removeEventListener('keydown', this.onKeyDown);

    this.isKeydownHandlerAttached = false;
  }

  onKeyDown = (event: KeyboardEvent) => {
    const key = event.keyCode || event.charCode;

    if (key === Key.Escape) {
      this.hideTooltip();
    }
  };

  showTooltip = () => {
    if (this.isVisible) {
      return;
    }

    this.isVisible = true;

    this.$tooltip.classList.remove('visible');
    this.$tooltip.style.removeProperty('display');

    this.attachKeydownHandler();

    window.setTimeout(() => {
      this.$tooltip.classList.add('visible');
    }, DELAY_CSS_TRANSITION);
  };

  hideTooltip = () => {
    this.isVisible = false;

    this.$tooltip.classList.remove('visible');
    this.$tooltip.style.display = 'none';

    this.showDelay.stop();

    this.removeGlobalListener();
  };
}

export default Tooltip;
